import type { ComponentType } from 'react'
import {
  Banknote,
  CalendarClock,
  CheckCheck,
  CircleHelp,
  CreditCard,
  Flower2,
  Globe,
  HandCoins,
  Link2,
  Wallet,
} from 'lucide-react'

import type { StyledIconTone } from '@/components/ui/styled-icon'

type ReportTenderStyle = {
  icon: ComponentType<{ className?: string }>
  tone: StyledIconTone
  color: string
}

const UNKNOWN_TENDER_STYLE: ReportTenderStyle = {
  icon: CircleHelp,
  tone: 'neutral',
  color: 'var(--color-muted-foreground)',
}

// One look per report payment method, shared by Sales Summary and Sales Statistics.
export const REPORT_TENDER_STYLES: Record<string, ReportTenderStyle> = {
  cash: { icon: Banknote, tone: 'mint', color: 'var(--color-chart-1)' },
  check: { icon: CheckCheck, tone: 'brand', color: 'var(--color-chart-3)' },
  card: { icon: CreditCard, tone: 'periwinkle', color: 'var(--color-chart-2)' },
  klarna: { icon: CalendarClock, tone: 'brand', color: 'var(--color-chart-3)' },
  afterpay_clearpay: { icon: CalendarClock, tone: 'mint', color: 'var(--color-chart-4)' },
  link: { icon: Link2, tone: 'info', color: 'var(--color-chart-6)' },
  unknown: UNKNOWN_TENDER_STYLE,
  paid_from_deposits: { icon: HandCoins, tone: 'mint', color: 'var(--color-chart-6)' },
  house_account: { icon: Wallet, tone: 'amethyst', color: 'var(--color-chart-5)' },
  fsn_network: { icon: Globe, tone: 'periwinkle', color: 'var(--color-chart-4)' },
  condolences: { icon: Flower2, tone: 'brand', color: 'var(--color-chart-5)' },
}

// Reports can return methods this map doesn't know yet; style them as unknown instead of failing.
export function reportTenderStyle(key: string): ReportTenderStyle {
  return REPORT_TENDER_STYLES[key] ?? UNKNOWN_TENDER_STYLE
}
